// @flow

import _ from 'lodash';
import { isEmpty } from 'lodash';
import { createSelector } from 'reselect';
import type { TRootStore, TRound, TSquad, TSquadsById } from "../../types";
import { getActualRound } from '../rounds';



export const getSquads = (state: TRootStore): Array<TSquad> =>
	state.squads.ordered_ids.map(item => state.squads.by_id[item]);

export const getSquadsById = (state: TRootStore): TSquadsById => state.squads.by_id;

export const hasSquads = (state: TRootStore): boolean => !isEmpty(state.squads.ordered_ids);

export const getByeSquadIdsArray = createSelector(
	getActualRound,
	(round: TRound) => _.get(round, 'bye_squads', [])
);


// WEBPACK FOOTER //
// ./src/modules/selectors/squads/index.js